import { makeAutoObservable } from "mobx";

import "regenerator-runtime/runtime";
import RootStore from "~/store/RootStore";

export interface ICity {
  id: number;
  name: string;
  slug: string;
  area_name: string;
  area_code: number;
  default?: boolean;
}

class City {
  rootStore!: RootStore;

  currentCity: ICity | null = JSON.parse(
    (localStorage.getItem("currentCity") ?? "null").replace("undefined", "null")
  );

  constructor(rootStore?: RootStore) {
    makeAutoObservable(this);
    if (rootStore) {
      this.rootStore = rootStore;
    }
  }

  setCurrentCity(city: ICity) {
    this.currentCity = city;
  }

  get isMoscowRegion(): boolean {
    return !!(this.currentCity?.area_code === 77);
  }
}

export default City;
